import contentApi from "../../api/content";

const state = {
  content: []
};

const getters = {
  getContentById: state => contentId => {
    return _.find(state.content, function(content) {
      return content.id == contentId;
    });
  }
};

const actions = {
  populateContentById(context, contentId) {
    return new Promise((resolve, reject) => {
      contentApi
        .getContentById(contentId)
        .then(function(response) {
          context.commit("updateContent", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  updateContent(state, payload) {
    var index = _.findIndex(state.content, function(content) {
      return content.id === payload.id;
    });

    // add content to the array if it's new, update if not
    if (index > -1) {
      state.content.splice(index, 1, payload);
    } else {
      state.content.push(payload);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
